import React from 'react';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";

export const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/cs.sami'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/sami-ghorbel-04a4b185'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/sami_ghor'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/samighorbel93'},
]